import { z } from "zod";
/**
 * POST /v1/webhooks/whop — signed provider webhook, no end-user JWT and no
 * user-supplied Idempotency-Key (api-contracts.md: "no end-user JWT"). The
 * provider's own unique event ID is the dedup key, persisted to
 * `billing_events` per the billing webhook state machine.
 */
export const WhopWebhookEventSchema = z.object({
    id: z.string().describe("Unique provider event ID — the dedup key."),
    type: z.string(),
    data: z.record(z.string(), z.unknown()),
    createdAt: z.string(),
});
export const WhopWebhookAckResponseSchema = z.object({
    received: z.literal(true),
});
/**
 * POST /v1/webhooks/apple — App Store Server Notifications V2 (ADR-085). No
 * end-user JWT and no Idempotency-Key: the body is Apple's signed JWS
 * (`signedPayload`), verified against Apple's certificate chain, and
 * deduplicated by the notification's own `notificationUUID` in `billing_events`.
 */
export const AppleServerNotificationSchema = z.object({
    signedPayload: z.string().min(1),
});
export const AppleWebhookAckResponseSchema = z.object({
    received: z.literal(true),
});
//# sourceMappingURL=webhooks.js.map